export const statusColor: any = {
  successful: {
    color: "#C8E6C9",
    title: "Successful"
  },
  "partially refunded": {
    color: "#FFD4A1",
    title: "Partially Refunded"
  },
  "partial refund": {
    color: "#FFD4A1",
    title: "Partially Refunded"
  },
  "full refund": {
    color: "#EDE7F6",
    title: "Refunded"
  },
  refunded: {
    color: "#EDE7F6",
    title: "Refunded"
  }
};

export const positionOptions = [
  { name: "Owner", value: "Owner" },
  { name: "Manager", value: "Manager" },
  { name: "Staff", value: "Staff" },
  { name: "Accounting", value: "Accounting" },
  { name: "Other", value: "Other" }
];
